import isEmpty from 'lodash.isempty'
import { axiosInstance, getRequest } from 'src/utils/request-client'
import { logMessage, setLoginToken, getLoginToken } from 'src/utils/helpers'
import { resetApp } from 'src/modules/App/actions'
import { resetUser } from 'src/modules/Users/actions'

const renewToken = () => {
  return getRequest({ base: '/tokens/renew', mock: false }).then(({ token }) => token)
}

const appendToken = config => {
  const token = getLoginToken()
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}

export default {
  addAuthorizationHeader: () => {
    axiosInstance.interceptors.request.use(
      config => {
        return appendToken(config)
      },
      error => {
        // Do something with request error
        return Promise.reject({ error })
      },
    )
  },
  setupInterceptors: store => {
    const logoutUser = () => {
      // This can happen when using login token to login (e.g. with "Login as Kiosk user" or from new email link), if token expired for example
      // It can also happen when kiosk token expired in backend and you re-open kiosk where you were logged in
      store.dispatch(resetApp())
      store.dispatch(resetUser())
    }

    axiosInstance.interceptors.request.use(
      config => {
        const { appReducer } = store.getState()
        config.headers['Accept-Language'] = appReducer.language
        config.headers['Version'] = process.env.REACT_APP_VERSION
        if (appReducer.selectedLanguage) {
          config.headers['Selected-Language'] = appReducer.selectedLanguage
        }

        return appendToken(config)
      },
      error => {
        // Do something with request error
        return Promise.reject({ error })
      },
    )

    axiosInstance.interceptors.response.use(
      response => {
        if (!response.data) {
          return response
        }
        return response && response.data && response.data.data
      },
      async error => {
        const { response } = error
        const { user } = store.getState()

        if (!response) {
          return Promise.reject(error)
        }

        if (response.config.url.indexOf('tokens/renew') > -1) {
          logMessage('Logging out user')
          logoutUser()
          return Promise.reject(error)
        }

        if (
          response.status === 401 &&
          response.config &&
          !response.config.__isRetryRequest &&
          !isEmpty(user.user)
        ) {
          logMessage('Token expired, getting a new token')
          try {
            // update the error config with new token
            const token = await renewToken()

            error.response.config.__isRetryRequest = true
            error.config.headers.Authorization = token
            setLoginToken(token)
            return axiosInstance(error.response.config)
          } catch (e) {
            logMessage('Logging out user, invalid token!')
            logoutUser()
            return Promise.reject(error)
          }
        } else if (response.status === 401 && response.config && response.config.__isRetryRequest) {
          return Promise.reject(error)
        }

        return Promise.reject(error)
      },
    )
  },
}
